import React from "react";

import * as S from "../styled";
import { ModalContext } from "../SuccessMessageModal";

function Body(props) {
  return (
    <ModalContext.Consumer>
      {context => <S.ModalBody {...props} layout={context.layout} />}
    </ModalContext.Consumer>
  );
}

export default Body;
